/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  50% {
    opacity: .5;
  }
`;

const StyledSkeleton = styled.div`
  ${(props) => props.$style && props.$style}
  background: rgba(${({ theme }) => theme.colors.text.rgb}, 0.1);
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;

const Skeleton = ({ width, height, borderRadius, ...props }) => {
  return <StyledSkeleton aria-hidden="true" $style={{ width, height, borderRadius }} {...props} />;
};

export default Skeleton;
